import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function HomePage() {
  const { user } = useAuth();

  return (
    <div>
      {/* Hero */}
      <div className="hero">
        <h1>Laundry,<br />Delivered to You</h1>
        <p>Connect with nearby laundry shops. Schedule pickup, track status, get delivery at your door.</p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          {user ? (
            <Link to={user.role === 'customer' ? '/customer/new-order' : '/owner/requests'} className="btn btn-accent btn-lg">
              {user.role === 'customer' ? '👕 Place New Order' : '📋 View Requests'}
            </Link>
          ) : (
            <>
              <Link to="/login" className="btn btn-accent btn-lg">Get Started →</Link>
              <Link to="/shops" className="btn btn-outline btn-lg" style={{ borderColor: 'white', color: 'white' }}>
                Browse Shops
              </Link>
            </>
          )}
        </div>
      </div>

      {/* How it works */}
      <div className="page" style={{ padding: '4rem 2rem' }}>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h2 style={{ fontSize: '2rem' }}>How It Works</h2>
          <p style={{ color: 'var(--text-muted)', marginTop: 8 }}>Simple, fast, and reliable laundry service</p>
        </div>

        <div className="grid-3">
          {[
            { icon: '📍', title: 'Share Location', desc: 'We find laundry shops near you automatically.' },
            { icon: '🧺', title: 'Place Order', desc: 'Choose your clothes count & services needed.' },
            { icon: '🏪', title: 'Shop Accepts', desc: 'Nearby shops get notified. First to accept wins.' },
            { icon: '🚗', title: 'Pickup', desc: 'The laundry person comes to your door.' },
            { icon: '✨', title: 'Cleaned', desc: 'Your clothes are washed and prepared.' },
            { icon: '🎉', title: 'Delivered', desc: 'Fresh clothes returned to your home.' },
          ].map((step, i) => (
            <div key={i} className="card">
              <div className="card-body" style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '2.5rem', marginBottom: 12 }}>{step.icon}</div>
                <h3 style={{ marginBottom: 8, fontSize: '1rem' }}>{step.title}</h3>
                <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA for shop owners */}
        <div style={{ marginTop: '4rem', background: 'linear-gradient(135deg, #0f172a, #0284c7)', borderRadius: 20, padding: '3rem 2rem', textAlign: 'center', color: 'white' }}>
          <h2 style={{ fontSize: '1.8rem', marginBottom: 12 }}>Own a Laundry Shop?</h2>
          <p style={{ opacity: 0.85, marginBottom: 24 }}>Register your shop and start receiving orders from customers in your area.</p>
          <Link to="/login" className="btn btn-accent btn-lg">Register Your Shop →</Link>
        </div>
      </div>
    </div>
  );
}
